import type { Profile } from './api'
import { isBadge } from './badges'

/**
 * Progressive profile (Bez, 2026-10-07). Every connected wallet has a profile page at once, built from its public BNB Chain activity;
 * completing it is a short path, each step saying what it unlocks. Claiming is the one free signature (no transaction); editing anything
 * after it still asks for that signature when the browser holds none (MyProfile `ensureToken`).
 *
 * Linking X or Telegram is not offered: the CADINU profile does not support linked accounts (social API, 2026-10-07), so no step pretends to.
 * The blue Token team tick is optional and not counted: a token with the blue or gold tick grants it to its own team wallets (invitation only).
 */
export type StepId = 'claim' | 'handle' | 'avatar' | 'team'
export interface Step {
  id: StepId
  title: string
  unlocks: string
  done: boolean
  optional?: boolean
}

export function profileSteps(p: Profile | null) {
  const claimed = Boolean(p && p.state !== 'none')
  const steps: Step[] = [
    { id: 'claim', title: 'Claim your profile', unlocks: 'One free signature, no transaction. Unlocks editing, following people and your referral link.', done: claimed },
    { id: 'handle', title: 'Choose a handle', unlocks: 'Your @name on your profile, in share links and on competition leaderboards.', done: claimed && Boolean(p?.handle) },
    { id: 'avatar', title: 'Set an NFT avatar', unlocks: 'Your picture and level badge next to your name, and the Complete profile achievement.', done: claimed && Boolean(p?.avatar) },
    {
      id: 'team',
      title: 'Token team tick',
      unlocks: 'A blue tick when a token with the blue or gold tick lists this wallet in its team and you confirm. By invitation from the project.',
      done: claimed && (p?.teams ?? []).some(isBadge),
      optional: true,
    },
  ]
  const counted = steps.filter((s) => !s.optional)
  const done = counted.filter((s) => s.done).length
  return { steps, done, total: counted.length, next: counted.find((s) => !s.done) ?? null, claimed }
}
